import { Action, createReducer, on } from '@ngrx/store';

import { Feedback } from './feedback.models';
import { FeedbackActions, FeedbackApiActions } from './feedback.actions';

export interface FeedbackState {
  entity: null | Feedback;
  loading: boolean;
}

export const initialState: FeedbackState = {
  entity: null,
  loading: false,
};

const feedbackReducer = createReducer(
  initialState,
  on(
    FeedbackActions.send,
    (state): FeedbackState => ({
      ...state,
      loading: true,
    })
  ),
  on(
    FeedbackApiActions.sendSuccess,
    (state, { feedback }): FeedbackState => ({
      ...state,
      loading: false,
      entity: feedback,
    })
  ),
  on(
    FeedbackApiActions.sendFailure,
    (state): FeedbackState => ({
      ...state,
      loading: false,
    })
  )
);

export function reducer(state: FeedbackState | undefined, action: Action) {
  return feedbackReducer(state, action);
}
